import script from "./CoreProgramExpensesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreProgramExpensesView.vue?vue&type=script&setup=true&lang=js"

import "./CoreProgramExpensesView.vue?vue&type=style&index=0&id=3d7a8e26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7a8e26"]])

export default __exports__